import React from 'react';

const Loader = ({
  loadingText = '',
  type = 'spinner',
  entireScreen = true,
}) => {
  return (
    <div
      className={`loaderOverlay ${
        entireScreen ? 'entire-screen' : 'component-level'
      }`}
    >
      <div className='width-webkit-fill-available'>
        <div className="loading-img">
          {type === 'gif' && (
            <img
              alt="Loading"
              src="/images/gifs/loading.gif"
              width={393}
              height={342}
            />
          )}
          {type === 'spinner' && <div className="loader" />}
          {type === 'progressBar' && (
            <div className="loading-progressBarContainer">
              <div className="loading-progressBar"></div>
            </div>
          )}
        </div>
        {/* Loading title */}
        <h3 className="loading-title">{loadingText}</h3>
      </div>
    </div>
  );
};

export default Loader;
